import styled from '@emotion/styled';
import { Flex } from 'antd';

export const UploaderText = styled.div`
  color: #4d4d4d;
  margin-bottom: 12px;
`;

export const FormContainer = styled(Flex)`
  max-width: 30%;
  margin: 0 auto;
  min-height: 70vh;

  @media (max-width: 768px) {
    max-width: 60%;
  }

  @media (max-width: 480px) {
    max-width: 90%;
    padding: 0 1rem;
    min-height: 80vh;
  }
`;
